import { Navigate, useParams } from "react-router-dom";
import { graphql } from "@apollo/client/react/hoc";
import { useCoachingMembershipURL } from "utils";
import { withAuth } from "components/container/withAuth";
import Loading from "components/ui/Loading";
import { gql } from "@apollo/client";
import "./CoachPage.css";
import Wrapper from "components/ui/Wrapper";
const membershipQuery = gql`
  query Membership($membershipId: Int!) {
    user {
      membership(membershipId: $membershipId) {
        membershipId
        membershipType
        courseFirstMeetingStart
        thisWeeksReport {
          reportId
        }
        lastReport {
          reportId
        }
        nextMeeting {
          courseMeetingId
        }
        currentWeekMeeting {
          courseMeetingId
        }
      }
    }
  }
`;

function MembershipRedirectWrapped({ data, ...params }) {
  const coach_url = useCoachingMembershipURL(data?.user?.membership);
  if (data.loading || !data?.user?.membership) {
    return <Loading />;
  }

  return <Navigate replace to={coach_url} />;
}

const MembershipRedirect = graphql(membershipQuery, {
  options: ({ membershipId }) => ({ variables: { membershipId } }),
})(MembershipRedirectWrapped);

function RedirectToCourses() {
  return (
    <Wrapper className="ContentWrapper">
      <div className="coach-page-container">
        <div className="coach-page-content">
          <div className="coach-page-hero">
            <h1>Roede-kurs</h1>
            <div className="coach-page-description">
              <p>
                Personlig oppfølging med din dedikerte veileder som følger deg
                helt til mål: Individuelt eller i gruppe; fysisk eller digitalt.
              </p>
            </div>
          </div>

          <div className="coach-page-options">
            <h2>Hva passer best for deg?</h2>

            <a
              href="https://roede.com/blimed/medlemskap"
              className="coach-page-option primary"
            >
              <div className="coach-page-option-content">
                <div className="coach-page-option-title">Kursmedlemskap</div>
                <div className="coach-page-option-description">
                  Med medlemskap går du på kurs uten en definert sluttdato. Vi
                  følger deg helt til du har nådd målet ditt.
                </div>
              </div>
              <div className="coach-page-option-arrow">→</div>
            </a>

            <a
              href="https://roede.com/blimed/kurspakke"
              className="coach-page-option secondary"
            >
              <div className="coach-page-option-content">
                <div className="coach-page-option-title">Kurspakke</div>
                <div className="coach-page-option-description">
                  Velg oppfølging i 4, 8, 10 eller 16 uker
                </div>
              </div>
              <div className="coach-page-option-arrow">→</div>
            </a>
          </div>

          <div className="coach-page-footer">
            <p>
              For mer informasjon, besøk{" "}
              <a href="https://roede.com">roede.com</a>
            </p>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

function CoachPage({ auth }) {
  let params = useParams();
  let membershipId = params.membershipId;

  if (membershipId || auth?.user?.defaultCoachingMembership?.membershipId) {
    return (
      <MembershipRedirect
        membershipId={
          membershipId || auth?.user?.defaultCoachingMembership?.membershipId
        }
      />
    );
  }

  return <RedirectToCourses />;
}

export default withAuth(CoachPage);
